import { ColDef, GridOptions } from 'ag-grid-community';

export interface IProps {
  environment: string;
  release: string;
  isOpen: boolean;
  onClose: () => void;
  onApprove: () => Promise<void> | void;
  reviewQueries?: () => void;
  queryData: any[] | null;
}

export const columnDefs: ColDef[] = [
  {
    headerName: 'S.No',
    valueGetter: (params) => (params.node ? params.node.rowIndex + 1 : null),
    width: 80,
    suppressMenu: true,
    sortable: false,
  },
  {
    headerName: 'Release',
    field: 'release',
    width: 150,
    sortable: true,
  },
  {
    headerName: 'ID',
    field: 'id',
    width: 100,
    sortable: true,
  },
  {
    headerName: 'Query',
    field: 'query',
    valueGetter: (params) => params.data.query || params.data.sql || '',
    flex: 1,
    minWidth: 300,
    autoHeight: true,
    wrapText: true,
    cellStyle: {
      fontFamily: 'monospace',
      fontSize: '11px',
      lineHeight: '1.4',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-all',
      padding: '8px',
    },
  },
];

export const gridOptions: GridOptions = {
  defaultColDef: {
    sortable: false,
    resizable: true,
    filter: false,
    suppressMenu: true,
  },
  domLayout: 'normal' as const,
  enableCellTextSelection: true,
  suppressMovableColumns: true,
  getRowStyle: () => ({
    borderBottom: '1px solid #e0e0e0',
  }),
};
